import React, { useId } from "react";
import Select from "react-select";

export default function OrganizationTaskCategoryFields({ label, categoryIds, categories = [], onChange, disabled }) {
  const id = useId();
  const restricted = Array.isArray(categoryIds);
  return <div>
    <label className="form-label" htmlFor={`${id}-scope`}>Applies to</label>
    <select id={`${id}-scope`} className="form-select" aria-label={`Applies to ${label}`} disabled={disabled}
      value={restricted ? "categories" : "everyone"} onChange={event => onChange(event.target.value === "everyone" ? null : [])}>
      <option value="everyone">Everyone in this organization</option>
      <option value="categories">Selected employee categories</option>
    </select>
    {restricted && <div className="mt-2">
      <label className="form-label" htmlFor={`${id}-categories`}>Employee categories</label>
      <Select inputId={`${id}-categories`} aria-label={`Employee categories for ${label}`} isMulti isDisabled={disabled}
        classNamePrefix="react-select" options={categories.map(category => ({value:Number(category.id),label:category.name}))}
        value={categories.filter(category => categoryIds.includes(Number(category.id))).map(category => ({value:Number(category.id),label:category.name}))}
        onChange={selected => onChange((selected || []).map(option => option.value))} />
      {!categoryIds.length && <small className="text-danger">Select at least one employee category before saving.</small>}
    </div>}
  </div>;
}
